__turbopack_context__.v({
  "component": "style-module-scss-module__au243a__component",
  "container": "style-module-scss-module__au243a__container",
  "description": "style-module-scss-module__au243a__description",
  "imageContainer": "style-module-scss-module__au243a__imageContainer",
  "no-padding": "style-module-scss-module__au243a__no-padding",
});
